import script from "./DocumentPreSavePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentPreSavePreview.vue?vue&type=script&setup=true&lang=js"

import "./DocumentPreSavePreview.vue?vue&type=style&index=0&id=c0d775d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c0d775d4"]])

export default __exports__